export interface BossDrop {
  name: string;
  prob: number;
  qty: number;
  type: "unique" | "currency" | "fragment" | "gem" | "special";
  manualPriceKey?: string; // references a manual price override
}

export interface Boss {
  name: string;
  category: string;
  entryCost: { name: string; qty: number; type: "currency" | "fragment" }[];
  drops: BossDrop[];
  notes?: string;
}

export const BOSSES: Boss[] = [
  // ── MAVEN ────────────────────────────────────────────────────────────────
  {
    name: "The Maven",
    category: "Maven",
    entryCost: [{ name: "The Maven's Writ", qty: 1, type: "fragment" }],
    drops: [
      { name: "Legacy of Fury",      prob: 0.44, qty: 1, type: "unique" },
      { name: "Graven's Secret",     prob: 0.16, qty: 1, type: "unique" },
      { name: "Arn's Anguish",       prob: 0.16, qty: 1, type: "unique" },
      { name: "Olesya's Delight",    prob: 0.16, qty: 1, type: "unique" },
      { name: "Doppelgänger Guise",  prob: 0.07, qty: 1, type: "unique" },
      { name: "Echoforge",           prob: 0.01, qty: 1, type: "unique" },
      { name: "Eclipse Support",     prob: 0.02, qty: 1, type: "gem" },
      { name: "Invert the Rules Support", prob: 0.10, qty: 1, type: "gem" },
      { name: "Orb of Conflict",     prob: 0.30, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Uber Maven",
    category: "Maven",
    entryCost: [{ name: "Reality Fragment", qty: 4, type: "fragment" }],
    drops: [
      { name: "Viridi's Veil",        prob: 0.50, qty: 1, type: "unique" },
      { name: "Impossible Escape",    prob: 0.30, qty: 1, type: "unique" },
      { name: "Grace of the Goddess", prob: 0.18, qty: 1, type: "unique" },
      { name: "Progenesis",           prob: 0.02, qty: 1, type: "unique" },
      { name: "Awakened Empower Support",   prob: 0.0133, qty: 1, type: "gem" },
      { name: "Awakened Enhance Support",   prob: 0.0133, qty: 1, type: "gem" },
      { name: "Awakened Enlighten Support", prob: 0.0133, qty: 1, type: "gem" },
      { name: "Shiny Reliquary Key",  prob: 0.015, qty: 1, type: "fragment" },
      { name: "Curio of Potential",   prob: 0.05,  qty: 1, type: "unique" },
      { name: "Eclipse Support",      prob: 0.02,  qty: 1, type: "gem" },
      { name: "Invert the Rules Support", prob: 0.10, qty: 1, type: "gem" },
      { name: "Orb of Conflict",      prob: 0.30,  qty: 1, type: "currency" },
    ],
  },

  // ── SHAPER ───────────────────────────────────────────────────────────────
  {
    name: "The Shaper",
    category: "Shaper",
    entryCost: [
      { name: "Fragment of the Hydra",    qty: 1, type: "fragment" },
      { name: "Fragment of the Chimera",  qty: 1, type: "fragment" },
      { name: "Fragment of the Phoenix",  qty: 1, type: "fragment" },
      { name: "Fragment of the Minotaur", qty: 1, type: "fragment" },
    ],
    drops: [
      { name: "Shaper's Touch", prob: 0.56, qty: 1, type: "unique" },
      { name: "Voidwalker",     prob: 0.26, qty: 1, type: "unique" },
      { name: "Solstice Vigil", prob: 0.15, qty: 1, type: "unique" },
      { name: "Dying Sun",      prob: 0.03, qty: 1, type: "unique" },
      { name: "Shaper's Exalted Orb", prob: 0.12, qty: 1, type: "currency" },
      { name: "Orb of Dominance",     prob: 0.03, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Uber Shaper",
    category: "Shaper",
    entryCost: [{ name: "Cosmic Fragment", qty: 4, type: "fragment" }],
    drops: [
      { name: "Echoes of Creation",    prob: 0.40, qty: 1, type: "unique" },
      { name: "Entropic Devastation",  prob: 0.36, qty: 1, type: "unique" },
      { name: "The Tides of Time",     prob: 0.22, qty: 1, type: "unique" },
      { name: "Starforge",             prob: 0.02, qty: 1, type: "unique" },
      { name: "Sublime Vision",        prob: 0.02, qty: 1, type: "unique" },
      { name: "Cosmic Reliquary Key",  prob: 0.01, qty: 1, type: "fragment" },
    ],
  },

  // ── ELDER ────────────────────────────────────────────────────────────────
  {
    name: "The Elder",
    category: "Elder",
    entryCost: [
      { name: "Fragment of Purification", qty: 1, type: "fragment" },
      { name: "Fragment of Constriction", qty: 1, type: "fragment" },
      { name: "Fragment of Enslavement",  qty: 1, type: "fragment" },
      { name: "Fragment of Eradication",  qty: 1, type: "fragment" },
    ],
    drops: [
      { name: "Fragment of Terror",   prob: 0.50, qty: 1, type: "fragment" },
      { name: "Fragment of Emptiness", prob: 0.50, qty: 1, type: "fragment" },
      { name: "Cyclopean Coil",       prob: 0.30, qty: 1, type: "unique" },
      { name: "Blasphemer's Grasp",   prob: 0.30, qty: 1, type: "unique" },
      { name: "Nebuloch",             prob: 0.10, qty: 1, type: "unique" },
      { name: "Hopeshredder",         prob: 0.10, qty: 1, type: "unique" },
      { name: "Shimmeron",            prob: 0.10, qty: 1, type: "unique" },
      { name: "Impresence",           prob: 0.10, qty: 1, type: "unique" },
      { name: "Watcher's Eye",        prob: 0.40, qty: 1, type: "special", manualPriceKey: "watchers2" },
      { name: "Elder's Exalted Orb",  prob: 0.10, qty: 1, type: "currency" },
      { name: "Orb of Dominance",     prob: 0.02, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Uber Elder",
    category: "Elder",
    entryCost: [
      { name: "Fragment of Knowledge", qty: 1, type: "fragment" },
      { name: "Fragment of Shape",     qty: 1, type: "fragment" },
      { name: "Fragment of Terror",    qty: 1, type: "fragment" },
      { name: "Fragment of Emptiness", qty: 1, type: "fragment" },
    ],
    drops: [
      { name: "Mark of the Shaper",  prob: 0.35, qty: 1, type: "unique" },
      { name: "Mark of the Elder",   prob: 0.35, qty: 1, type: "unique" },
      { name: "Voidfletcher",        prob: 0.15, qty: 1, type: "unique" },
      { name: "Indigon",             prob: 0.12, qty: 1, type: "unique" },
      { name: "Disintegrator",       prob: 0.03, qty: 1, type: "unique" },
      { name: "Watcher's Eye",       prob: 0.30, qty: 1, type: "special", manualPriceKey: "watchers3" },
      { name: "Shaper's Exalted Orb", prob: 0.15, qty: 1, type: "currency" },
      { name: "Elder's Exalted Orb",  prob: 0.10, qty: 1, type: "currency" },
      { name: "Orb of Dominance",     prob: 0.05, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Uber Uber Elder",
    category: "Elder",
    entryCost: [{ name: "Decaying Fragment", qty: 4, type: "fragment" }],
    drops: [
      { name: "Call of the Void",      prob: 0.40, qty: 1, type: "unique" },
      { name: "The Devourer of Minds", prob: 0.30, qty: 1, type: "unique" },
      { name: "Soul Ascension",        prob: 0.10, qty: 1, type: "unique" },
      { name: "Impresence",            prob: 0.10, qty: 1, type: "unique" },
      { name: "The Eternity Shroud",   prob: 0.06, qty: 1, type: "unique" },
      { name: "Voidforge",             prob: 0.04, qty: 1, type: "unique" },
      { name: "Sublime Vision",        prob: 0.01, qty: 1, type: "unique" },
      { name: "Decaying Reliquary Key", prob: 0.015, qty: 1, type: "fragment" },
      { name: "Curio of Decay",        prob: 0.05, qty: 1, type: "unique" },
      { name: "Watcher's Eye",         prob: 0.30, qty: 1, type: "special", manualPriceKey: "watchers3" },
      { name: "Shaper's Exalted Orb",  prob: 0.15, qty: 1, type: "currency" },
      { name: "Elder's Exalted Orb",   prob: 0.10, qty: 1, type: "currency" },
      { name: "Orb of Dominance",      prob: 0.05, qty: 1, type: "currency" },
    ],
  },

  // ── SIRUS ────────────────────────────────────────────────────────────────
  {
    name: "Sirus",
    category: "Sirus",
    entryCost: [
      { name: "Veritania's Crest", qty: 1, type: "fragment" },
      { name: "Drox's Crest",      qty: 1, type: "fragment" },
      { name: "Baran's Crest",     qty: 1, type: "fragment" },
      { name: "Al-Hezmin's Crest", qty: 1, type: "fragment" },
    ],
    drops: [
      { name: "Hands of the High Templar", prob: 0.40, qty: 1, type: "unique" },
      { name: "Crown of the Inward Eye",   prob: 0.35, qty: 1, type: "unique" },
      { name: "The Burden of Truth",       prob: 0.20, qty: 1, type: "unique" },
      { name: "Thread of Hope",            prob: 0.05, qty: 1, type: "unique" },
      { name: "Orb of Dominance",          prob: 0.10, qty: 1, type: "currency" },
      { name: "Awakener's Orb",            prob: 0.15, qty: 1, type: "currency" },
      { name: "A Fate Worse Than Death",   prob: 0.04, qty: 1, type: "unique" },
    ],
  },
  {
    name: "Uber Sirus",
    category: "Sirus",
    entryCost: [{ name: "Awakening Fragment", qty: 4, type: "fragment" }],
    drops: [
      { name: "Thread of Hope",      prob: 0.55, qty: 1, type: "unique" },
      { name: "The Tempest Rising",  prob: 0.37, qty: 1, type: "unique" },
      { name: "Oriath's End",        prob: 0.075, qty: 1, type: "unique" },
      { name: "The Saviour",         prob: 0.005, qty: 1, type: "unique" },
      { name: "Oubliette Reliquary Key", prob: 0.015, qty: 1, type: "fragment" },
    ],
  },

  // ── EXARCH ───────────────────────────────────────────────────────────────
  {
    name: "The Searing Exarch",
    category: "Exarch / Eater",
    entryCost: [{ name: "Incandescent Invitation", qty: 1, type: "fragment" }],
    drops: [
      { name: "Dawnbreaker",             prob: 0.63, qty: 1, type: "unique" },
      { name: "Dawnstrider",             prob: 0.35, qty: 1, type: "unique" },
      { name: "Dissolution of the Flesh", prob: 0.02, qty: 1, type: "unique" },
      { name: "Forbidden Flame",         prob: 0.05, qty: 1, type: "special", manualPriceKey: "forbiddenFlame" },
      { name: "Exceptional Eldritch Ember", prob: 0.15, qty: 1, type: "currency" },
      { name: "Eldritch Orb of Annulment", prob: 0.05, qty: 1, type: "currency" },
      { name: "Eldritch Chaos Orb",      prob: 0.05, qty: 1, type: "currency" },
      { name: "Eldritch Exalted Orb",    prob: 0.05, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Uber Searing Exarch",
    category: "Exarch / Eater",
    entryCost: [{ name: "Blazing Fragment", qty: 4, type: "fragment" }],
    drops: [
      { name: "The Annihilating Light",   prob: 0.455, qty: 1, type: "unique" },
      { name: "Annihilation's Approach",  prob: 0.29,  qty: 1, type: "unique" },
      { name: "Crystallised Omniscience", prob: 0.24,  qty: 1, type: "unique" },
      { name: "The Celestial Brace",      prob: 0.015, qty: 1, type: "unique" },
      { name: "Forbidden Flame",          prob: 0.05,  qty: 1, type: "special", manualPriceKey: "forbiddenFlame" },
      { name: "Archive Reliquary Key",    prob: 0.015, qty: 1, type: "fragment" },
      { name: "Curio of Absorption",      prob: 0.05,  qty: 1, type: "unique" },
    ],
    notes: "Forbidden Flame is guaranteed (hidden Ascendancy Notable variant)",
  },

  // ── EATER ────────────────────────────────────────────────────────────────
  {
    name: "The Eater of Worlds",
    category: "Exarch / Eater",
    entryCost: [{ name: "Screaming Invitation", qty: 1, type: "fragment" }],
    drops: [
      { name: "Inextricable Fate",  prob: 0.55, qty: 1, type: "unique" },
      { name: "The Gluttonous Tide", prob: 0.43, qty: 1, type: "unique" },
      { name: "Melding of the Flesh", prob: 0.02, qty: 1, type: "unique" },
      { name: "Forbidden Flesh",    prob: 0.05, qty: 1, type: "special", manualPriceKey: "forbiddenFlesh" },
      { name: "Exceptional Eldritch Ichor", prob: 0.15, qty: 1, type: "currency" },
      { name: "Eldritch Orb of Annulment",  prob: 0.05, qty: 1, type: "currency" },
      { name: "Eldritch Chaos Orb",         prob: 0.05, qty: 1, type: "currency" },
      { name: "Eldritch Exalted Orb",       prob: 0.05, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Uber Eater of Worlds",
    category: "Exarch / Eater",
    entryCost: [{ name: "Devouring Fragment", qty: 4, type: "fragment" }],
    drops: [
      { name: "Ravenous Passion",  prob: 0.68, qty: 1, type: "unique" },
      { name: "Ashes of the Stars", prob: 0.30, qty: 1, type: "unique" },
      { name: "Nimis",             prob: 0.02, qty: 1, type: "unique" },
      { name: "Forbidden Flesh",   prob: 0.05, qty: 1, type: "special", manualPriceKey: "forbiddenFlesh" },
      { name: "Visceral Reliquary Key", prob: 0.01, qty: 1, type: "fragment" },
      { name: "Curio of Consumption",   prob: 0.05, qty: 1, type: "unique" },
    ],
    notes: "Forbidden Flesh is guaranteed (hidden Ascendancy Notable variant)",
  },

  // ── INCARNATIONS (Allflame) ─────────────────────────────────────────────────
  {
    name: "Regular Neglect",
    category: "Incarnations",
    entryCost: [{ name: "Echo of Loneliness", qty: 1, type: "fragment" }],
    drops: [
      { name: "Betrayal's Sting",      prob: 0.50, qty: 1, type: "unique" },
      { name: "The Arkhon's Tools",    prob: 0.38, qty: 1, type: "unique" },
      { name: "Venarius' Astrolabe",   prob: 0.10, qty: 1, type: "unique" },
      { name: "Legacy of the Rose",    prob: 0.02, qty: 1, type: "unique" },
      { name: "Bound By Destiny",      prob: 0.10, qty: 1, type: "special", manualPriceKey: "boundByDestiny" },
      { name: "Orb of Remembrance",    prob: 0.33, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Uber Neglect",
    category: "Incarnations",
    entryCost: [{ name: "Lonely Fragment", qty: 4, type: "fragment" }],
    drops: [
      { name: "Refuge in Isolation",  prob: 0.55, qty: 1, type: "unique" },
      { name: "Bitter Instinct",       prob: 0.30, qty: 1, type: "unique" },
      { name: "Haunting Memories",     prob: 0.13, qty: 1, type: "unique" },
      { name: "Festering Resentment",  prob: 0.02, qty: 1, type: "unique" },
      { name: "Lonely Reliquary Key",  prob: 0.01, qty: 1, type: "fragment" },
      { name: "Bound By Destiny",      prob: 0.10, qty: 1, type: "special", manualPriceKey: "boundByDestiny" },
      { name: "Orb of Remembrance",    prob: 0.33, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Regular Fear",
    category: "Incarnations",
    entryCost: [{ name: "Echo of Trauma", qty: 1, type: "fragment" }],
    drops: [
      { name: "The Unseen Hue",    prob: 0.33, qty: 1, type: "unique" },
      { name: "Servant of Decay",  prob: 0.33, qty: 1, type: "unique" },
      { name: "Enmity's Embrace",  prob: 0.33, qty: 1, type: "unique" },
      { name: "Starcaller",        prob: 0.02, qty: 1, type: "unique" },
      { name: "Bound By Destiny",  prob: 0.10, qty: 1, type: "special", manualPriceKey: "boundByDestiny" },
      { name: "Orb of Intention",  prob: 0.50, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Uber Fear",
    category: "Incarnations",
    entryCost: [{ name: "Traumatic Fragment", qty: 4, type: "fragment" }],
    drops: [
      { name: "Coiling Whisper",       prob: 0.33, qty: 1, type: "unique" },
      { name: "The Caged Mammoth",     prob: 0.33, qty: 1, type: "unique" },
      { name: "Wing of the Wyvern",    prob: 0.33, qty: 1, type: "unique" },
      { name: "Woespike",              prob: 0.02, qty: 1, type: "unique" },
      { name: "Traumatic Reliquary Key", prob: 0.01, qty: 1, type: "fragment" },
      { name: "Bound By Destiny",      prob: 0.10, qty: 1, type: "special", manualPriceKey: "boundByDestiny" },
      { name: "Orb of Intention",      prob: 0.50, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Regular Dread",
    category: "Incarnations",
    entryCost: [{ name: "Echo of Reverence", qty: 1, type: "fragment" }],
    drops: [
      { name: "Bonemeld",          prob: 0.55, qty: 1, type: "unique" },
      { name: "The Dark Monarch",  prob: 0.35, qty: 1, type: "unique" },
      { name: "Seven Teachings",   prob: 0.08, qty: 1, type: "unique" },
      { name: "Wine of the Prophet", prob: 0.02, qty: 1, type: "unique" },
      { name: "Bound By Destiny",  prob: 0.10, qty: 1, type: "special", manualPriceKey: "boundByDestiny" },
      { name: "Orb of Unravelling", prob: 0.33, qty: 1, type: "currency" },
    ],
  },
  {
    name: "Uber Dread",
    category: "Incarnations",
    entryCost: [{ name: "Reverent Fragment", qty: 4, type: "fragment" }],
    drops: [
      { name: "The Hallowed Monarch",   prob: 0.54, qty: 1, type: "unique" },
      { name: "Whispers of Infinity",   prob: 0.30, qty: 1, type: "unique" },
      { name: "Wellwater Phylactery",   prob: 0.14, qty: 1, type: "unique" },
      { name: "The Golden Charlatan",   prob: 0.02, qty: 1, type: "unique" },
      { name: "Reverent Reliquary Key", prob: 0.01, qty: 1, type: "fragment" },
      { name: "Bound By Destiny",       prob: 0.10, qty: 1, type: "special", manualPriceKey: "boundByDestiny" },
      { name: "Orb of Unravelling",     prob: 0.33, qty: 1, type: "currency" },
    ],
  },

  // ── KING OF THE MISTS ─────────────────────────────────────────────────────
  {
    name: "King of the Mists",
    category: "Incarnations",
    entryCost: [{ name: "An Audience With The King", qty: 1, type: "fragment" }],
    drops: [
      { name: "The Untouched Soul",   prob: 0.40, qty: 1, type: "unique" },
      { name: "Pragmatism",           prob: 0.35, qty: 1, type: "unique" },
      { name: "The Light of Meaning", prob: 0.20, qty: 1, type: "special", manualPriceKey: "lightOfMeaning" },
      { name: "The Burden of Shadows", prob: 0.05, qty: 1, type: "unique" },
      { name: "The Endless Darkness",  prob: 0.10, qty: 1, type: "unique" },
    ],
  },
];

// Manual price keys used in the bossing tab
export const MANUAL_PRICE_KEYS: { key: string; label: string; defaultDiv: number }[] = [
  { key: "watchers2",      label: "Watcher's Eye (2-mod)",  defaultDiv: 0 },
  { key: "watchers3",      label: "Watcher's Eye (3-mod)",  defaultDiv: 0 },
  { key: "forbiddenFlame", label: "Forbidden Flame (avg)",  defaultDiv: 0 },
  { key: "forbiddenFlesh", label: "Forbidden Flesh (avg)",  defaultDiv: 0 },
  { key: "lightOfMeaning", label: "The Light of Meaning",   defaultDiv: 0 },
  { key: "boundByDestiny", label: "Bound By Destiny",        defaultDiv: 0 },
];
